import { useQuery } from '@tanstack/react-query';
import { IRole } from '../../Interfaces/IRole';
import { customFetcher } from '../useFetch';

export const useGetRoles = () => {
  const { data: roles, isLoading: isLoadingRoles } = useQuery<IRole[]>({
    queryKey: ['role'],
    queryFn: () => customFetcher({ endpoint: '/role' }),
  });

  return { roles, isLoadingRoles };
};
